import { IconCode, IconInbox, IconMessage, IconPhone, IconPhoneCall, IconSettings, IconShare3, IconTrendingUp } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Layout from '../../layout/Layout'
import CallList from './SubViews/CallList'
import CallList2 from './SubViews/CallList2'
import CannedReply from './SubViews/CannedReply'
import ChatFeedback from './SubViews/ChatFeedback'
import ChatReports from './SubViews/ChatReports'
import ChatSection from './SubViews/ChatSection'
import ChatSettings from './SubViews/ChatSettings'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'
import ChatDocumentation from './SubViews/ChatDocumentation'

const LiveChat = () => {
    const [searchParams, setSearchParams] = useSearchParams({ tab: "" });
    const activeTab = searchParams.get('tab') || '1';
    const [currentMenu, setCurrentMenu] = useState(activeTab);

    useEffect(() => {
        setCurrentMenu(activeTab || 1);
        return () => { };
    }, [activeTab]);

    const menu = [{
        id: 1,
        icon: <IconInbox size={28} stroke={1.5} />,
        name: "Chat",
        component: <ChatSection />,
        access: accessCheck(accessKeys.createAndUpdateChatSession)
    },
    // {
    //     id: 2,
    //     icon: <IconPhone size={28} stroke={1.5} />,
    //     name: "Calls",
    //     component: <CallList />
    // }, 
    {
        id: 3,
        icon: <IconShare3 size={28} stroke={1.5} />,
        name: "Canned Reply",
        component: <CannedReply />,
        access: accessCheck(accessKeys.createAndUpdateCannedReplies)
    }, {
        id: 4,
        icon: <IconTrendingUp size={28} stroke={1.5} />,
        name: "Reports",
        component: <ChatReports />,
        access: accessCheck(accessKeys.chatReportData)
    }, {
        id: 5,
        icon: <IconMessage size={28} stroke={1.5} />,
        name: "Feedback",
        component: <ChatFeedback />,
        access: true
    }, {
        id: 6,
        icon: <IconSettings size={28} stroke={1.5} />,
        name: "Chat Setting",
        component: <ChatSettings />,
        access: true
    },
    // {
    //     id: 7,
    //     icon: <IconPhoneCall size={28} stroke={1.5} />,
    //     name: "Call2",
    //     component: <CallList2 />
    // },
    {
        id: 7,
        icon: <IconCode size={28} stroke={1.5} />,
        name: "Documentation",
        component: <ChatDocumentation />,
        access: true
    }
    ]

    const handleTabClick = (tabIndex) => {
        setCurrentMenu(tabIndex);
        setSearchParams({ tab: tabIndex }, { replace: true });
    }

    return (
        <Layout>

            <div className="flex gap-3 h-[88vh]">
                <div className='max-w-[200px] px-1'>
                    <p className='font-semibold mb-3'>Live Chat</p>
                    {
                        menu?.map((item, index) => {
                            return (
                                item?.access &&
                                <div className={`cursor-pointer rounded-lg !p-2 mb-4 ${item?.id == currentMenu ? '!bg-primary text-white' : ''}`} key={index} onClick={() => handleTabClick(item.id)}>
                                    <div className=''>
                                        <div className="flex flex-col items-center !gap-1">
                                            {item?.icon}
                                            <p className='mb-0 text-xs whitespace-pre'>{item?.name}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className='flex-1'>
                    {
                        menu.find(item => item.id == currentMenu)?.component
                    }
                </div>
            </div>

        </Layout>
    )
}

export default LiveChat